import cx from "classnames";

import { useBreakpoints } from "client/common/hooks";

import styles from "../../styles/Tooltip.module.less";

type TooltipProps = {
  content: React.ReactNode;
  isEnabled: boolean;
  children: React.ReactNode;
  className?: string;
  popoverClassName?: string;
  position?: "above" | "below";
  align?: "left" | "right";
  maxWidth?: number;
  /** Use "span" when the tooltip is rendered inside phrasing-only contexts like headings */
  elementType?: "div" | "span";
};

const Tooltip = ({
  content,
  isEnabled,
  children,
  className,
  popoverClassName,
  position = "above",
  align = "left",
  maxWidth,
  elementType: ElementType = "div",
}: TooltipProps) => {
  const { isPhoneAndSmaller } = useBreakpoints();

  if (!isEnabled) {
    return <>{children ?? null}</>;
  }

  return (
    <ElementType className={cx(styles.container, className)}>
      {children}
      <ElementType
        className={cx(
          styles.tooltip,
          styles[`position-${position}`],
          styles[`align-${align}`],
          popoverClassName,
        )}
        // Only allow max width overrides on larger views
        style={!isPhoneAndSmaller && maxWidth ? { maxWidth: `${maxWidth}px` } : undefined}
      >
        {content}
      </ElementType>
    </ElementType>
  );
};

export default Tooltip;
